export enum InventoryStatus {
    Selling_InventoryUnavailable = "Selling_InventoryUnavailable",
    Selling_InventoryInStock = "Selling_InventoryInStock",
    NotSelling_OutOfStock = "NotSelling_OutOfStock",
    NotSelling_ReOrdering = "NotSelling_ReOrdering",
}
